module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/device_mobile_2-0ec1894b5e2e897a3ecc9339301cea22.webp";